import { ApplicationConfig, InjectionToken, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { environment } from "../environments/environment";
import { provideHttpClient } from '@angular/common/http';

export const ENV_TOKEN = new InjectionToken('ENV');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: ENV_TOKEN,
      useValue: environment.env
    }
  ]
};
